import styled from 'styled-components';
export var Link = styled.a(function (_a) {
    var theme = _a.theme;
    return ({
        color: theme.palette.primary
    });
});
